module.exports = __webpack_public_path__ + "img/day11.198669e2.svg";